import IncomeDetailModal from './income-detail-modal.vue'
export default IncomeDetailModal
